<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1047735" style="color: #82a339"><b>SHRIMP RILLETTES</b></p>
<p class="ext" id="d7e1048235"><b><i>This rich, pâté-like spread is served cold as an appetizer on bread or toast. To make ahead, freeze rillettes in jars or ramekins up to three weeks. Make sure to place jars in freezer-weight plastic storage bags, or wrap ramekins well in foil before freezing. Before serving, thaw in refrigerator overnight. Present rillettes with a French baguette or assorted crackers.</i></b></p>
<p class="ser"><img alt="9781618371621_0035_001" src="Images/9781618371621_0035_001.jpg" style="max-width:100%;"/></p>
<p class="cap" id="d7e1051035"><i>Shrimp Rillettes</i></p>
<p class="h4" id="d7e1051535" style="color: #496210"><b>Prep: 15 minutes plus chilling      Cook: 3 minutes</b></p>
<p class="ul" id="d7e1052135">6 tablespoons butter (no substitutions), softened</p>
<p class="ul" id="d7e1052435">1 pound shelled and deveined shrimp</p>
<p class="ul" id="d7e1052735">2 tablespoons brandy or dry sherry</p>
<p class="ul" id="d7e1053035">¼ teaspoon ground red pepper (cayenne)</p>
<p class="ul" id="d7e1054035">2 tablespoons fresh lemon juice</p>
<p class="ul" id="d7e1054335">¼ teaspoon salt</p>
<p class="pub" id="d7e1055435" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 10-inch skillet, heat 2 tablespoons butter on medium-high until melted. Add shrimp and cook 2 minutes or until shrimp turn opaque throughout, stirring frequently. Add brandy and cook 30 seconds. Transfer shrimp mixture to food processor with knife blade attached; pulse until finely chopped.</p>
<p class="pub" id="d7e1057935"><span style="color: #c15b49"><b>2.</b></span> To shrimp mixture in processor, add ground red pepper, lemon juice, remaining 4 tablespoons butter, and salt; pulse until evenly blended.</p>
<p class="pub" id="d7e1059335"><span style="color: #c15b49"><b>3.</b></span> Transfer shrimp mixture to 3 small jars and cover with plastic wrap, pressing wrap directly onto surface of shrimp mixture. Refrigerate at least 8 hours to blend flavors or up to 3 days. Let stand 30 minutes at room temperature before serving. Makes 1¾ cups, or three 6-ounce jars of 6 servings each.</p>
<p class="ntx" id="d7e1062635">Each serving: About 75 calories, 6g protein, 0g carbohydrate, 5g total fat (3g saturated), 0g fiber, 55mg cholesterol, 125mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c21_r1.vue?31e31ae0